import { useState } from 'react';
import ChatInput from '../../../components/shared/chat-input/ChatInput';
import ChatContent from '../chats/ChatContent';
import LogoHomepage from '../../../components/shared/logo-homepage/LogoHomepage';
import { classNames } from '../../../utils/classNames';
import CheckSfaffLoggedIn from '../../staff/trips-login/CheckSfaffLoggedIn';
import { useNavigate } from 'react-router-dom';

const Homepage = () => {
	const navigate = useNavigate();
	const [isChatting, setIsChatting] = useState<boolean>(false);
	const [tripId, setTripId] = useState<string>();

	const handleSetTrip = (tripId: string) => setTripId(tripId);
	const handleShowChatting = () => {
		navigate(`/staff/chat/${tripId}`);
		setIsChatting(true);
	}
	

    return (
        <div className=' justify-center items-center pt-8 mx-auto mt-auto'>
			<div className={classNames('transition-all mb-5', isChatting ? 'h-[80vh] md:h-[calc(100vh-270px)]' : 'h-0')}>
				{isChatting && <ChatContent isFromHomepage={true}/>}
			</div>
			<CheckSfaffLoggedIn handleSetTrip={handleSetTrip} />
			{tripId && <ChatInput onSend={handleShowChatting} />}
			{!isChatting && <LogoHomepage />}
        </div>
    )
}

export default Homepage;